// The app's accent color. The palettes themselves are in theme.css, keyed by
// the id used here as `data-theme` on <html>; the default (Oceano) is the one
// with no attribute at all.
export const THEMES = [
    {id: "oceano", label: "Oceano", color: "#0b3d91"},
    {id: "rosa", label: "Hot pink", color: "#ff1493"},
    {id: "floresta", label: "Floresta", color: "#1b5e20"},
    {id: "tangerina", label: "Tangerina", color: "#d04a02"},
    // the accent is the violet; the swatch shows the whole mix
    {
        id: "arcoiris",
        label: "Arco-íris",
        color: "#7c3aed",
        swatch: "conic-gradient(#e53935, #fb8c00, #fdd835, #43a047, #1e88e5, #7c3aed, #d81b60, #e53935)",
    },
];

export const DEFAULT_THEME = THEMES[0].id;
const KEY = "ordo-theme";

const known = (id) => THEMES.some((theme) => theme.id === id);

/** The saved choice, or the default (also when storage is unavailable). */
export const savedTheme = () => {
    try {
        const id = localStorage.getItem(KEY);
        return known(id) ? /** @type {string} */ (id) : DEFAULT_THEME;
    } catch {
        return DEFAULT_THEME;
    }
};

const CHANGED = "ordo:theme";

/** Shows a theme right away; unknown ids fall back to the default. */
export const applyTheme = (id) => {
    const root = document.documentElement;
    if (!known(id) || id === DEFAULT_THEME) {
        root.removeAttribute("data-theme");
    } else {
        root.setAttribute("data-theme", id);
    }
    window.dispatchEvent(new Event(CHANGED));
};

/** What is showing now. */
export const currentTheme = () => {
    const id = document.documentElement.getAttribute("data-theme");
    return known(id) ? /** @type {string} */ (id) : DEFAULT_THEME;
};

/** Subscribes to every change of the theme on show; returns the way to stop. */
export const onThemeChanged = (callback) => {
    window.addEventListener(CHANGED, callback);
    return () => window.removeEventListener(CHANGED, callback);
};

/** Shows a theme and remembers it for next time. */
export const chooseTheme = (id) => {
    applyTheme(id);
    try {
        localStorage.setItem(KEY, known(id) ? id : DEFAULT_THEME);
    } catch {
        // Private window or blocked storage: the choice lasts until the page closes.
    }
};

/**
 * The provider's saved theme, as the server has it, is what the app wears:
 * show it and keep it in the browser too, so the next load starts right.
 * Nothing saved means the default.
 */
export const syncTheme = (id) => chooseTheme(id ?? DEFAULT_THEME);
